import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'ums/v1/crm/brands/poc/calls/stats';
export const getPocAgentCallsStatsEndpointIdentifier = endpoint;

export interface IPocAgentCallStatsData {
  totalCalls: number;
  totalCost: {
    value: number;
    currencyCode: string;
    currencySymbol: string;
  };
  totalContacts: number;
  sentiments: {
    positive: number;
    negative: number;
    neutral: number;
    unknown: number;
  };
}

type TData = IPocAgentCallStatsData;

type TError = AxiosError;
type TQueryKey = [typeof endpoint];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetPocAgentCallsStatsApi(options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const { data } = await http.get(endpoint);

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      throw error;
    }
  };

  return useQueryWrapper([endpoint], queryFn, {
    enabled: isLoggedIn,
    ...options,
  });
}
